import { useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "./App.css";
import routes from "./routes";

function App() {
  let router = useRoutes(routes);

  return (
    <div className="App">
      {/* <Header /> */}
      <main>{router}</main>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
      />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
